function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require("react");

var PropTypes = require("prop-types");

var childContextTypes = {
  injections: PropTypes.arrayOf(PropTypes.shape({
    target: PropTypes.any,
    source: PropTypes.any
  }))
};

var InjectionProvider =
/*#__PURE__*/
function (_React$Component) {
  _inherits(InjectionProvider, _React$Component);

  function InjectionProvider() {
    _classCallCheck(this, InjectionProvider);

    return _possibleConstructorReturn(this, (InjectionProvider.__proto__ || Object.getPrototypeOf(InjectionProvider)).apply(this, arguments));
  }

  _createClass(InjectionProvider, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        injections: this.props.injections
      };
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      return React.Children.only(props.children);
    }
  }]);

  return InjectionProvider;
}(React.Component);

InjectionProvider.childContextTypes = childContextTypes;

function inject(RawComponent) {
  var InjectedComponent = function InjectedComponent(props, context) {
    var injections = Array.isArray(context.injections) ? context.injections : [];
    var applicable = injections.find(function (injection) {
      return injection.target === RawComponent || injection.target.RawComponent === RawComponent;
    });

    if (!applicable) {
      return React.createElement(RawComponent, props, props.children);
    }

    var Source = applicable.source;
    return React.createElement(Source, props, props.children);
  };

  InjectedComponent.RawComponent = RawComponent;
  InjectedComponent.contextTypes = childContextTypes;
  return InjectedComponent;
}

module.exports.InjectionProvider = InjectionProvider;
module.exports.inject = inject;
//# sourceMappingURL=injection.js.map